import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import ServerModal from './ServerModal';
import ClientProvider from './client';
export default createDemo(import.meta.url, ServerModal, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/modal/demos/server/ServerModal.tsx",
    "fileName": "ServerModal.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport Modal from '@mui/material/Modal';\nimport Typography from '@mui/material/Typography';\nimport Box from '@mui/material/Box';\n\nexport default function ServerModal() {\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 0,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  const rootRef = React.useRef<HTMLDivElement>(null);\n\n  return (\n    <Box\n      sx={{\n        height: 300,\n        flexGrow: 1,\n        minWidth: 300,\n        transform: 'translateZ(0)',\n      }}\n      ref={rootRef}\n    >\n      <Modal\n        disablePortal\n        disableEnforceFocus\n        disableAutoFocus\n        open\n        aria-labelledby=\"server-modal-title\"\n        aria-describedby=\"server-modal-description\"\n        sx={{\n          display: 'flex',\n          p: 1,\n          alignItems: 'center',\n          justifyContent: 'center',\n        }}\n        container={() => rootRef.current!}\n      >\n        <Box\n          sx={(theme) => ({\n            position: 'relative',\n            width: 400,\n            bgcolor: 'background.paper',\n            border: '2px solid #000',\n            boxShadow: theme.shadows[5],\n            p: 4,\n          })}\n        >\n          <Typography id=\"server-modal-title\" variant=\"h6\" component=\"h2\">\n            Server-side modal\n          </Typography>\n          <Typography id=\"server-modal-description\" sx={{ pt: 2 }}>\n            If you disable JavaScript, you will still see me.\n          </Typography>\n        </Box>\n      </Modal>\n    </Box>\n  );\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 54,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport Modal from '@mui/material/Modal';\nimport Typography from '@mui/material/Typography';\nimport Box from '@mui/material/Box';\n\nexport default function ServerModal() {\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 0
        },
        "  const rootRef = React.useRef<HTMLDivElement>(null);\n\n  return (\n    <Box\n      sx={{\n        height: 300,\n        flexGrow: 1,\n        minWidth: 300,\n        transform: 'translateZ(0)',\n      }}\n      ref={rootRef}\n    >\n      <Modal\n        disablePortal\n        disableEnforceFocus\n        disableAutoFocus\n        open\n        aria-labelledby=\"server-modal-title\"\n        aria-describedby=\"server-modal-description\"\n        sx={{\n          display: 'flex',\n          p: 1,\n          alignItems: 'center',\n          justifyContent: 'center',\n        }}\n        container={() => rootRef.current!}\n      >\n        <Box\n          sx={(theme) => ({\n            position: 'relative',\n            width: 400,\n            bgcolor: 'background.paper',\n            border: '2px solid #000',\n            boxShadow: theme.shadows[5],\n            p: 4,\n          })}\n        >\n          <Typography id=\"server-modal-title\" variant=\"h6\" component=\"h2\">\n            Server-side modal\n          </Typography>\n          <Typography id=\"server-modal-description\" sx={{ pt: 2 }}>\n            If you disable JavaScript, you will still see me.\n          </Typography>\n        </Box>\n      </Modal>\n    </Box>\n  );\n"
      ],
      [
        "span",
        "frame",
        "}\n"
      ]
    ],
    "totalLines": 54,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/Modal",
      "@mui/material/Typography",
      "@mui/material/Box"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
